import { Component } from '@angular/core';

@Component({
    selector: 'app-report-general-cdms',
    templateUrl: './report-general-cdms.component.html',
    styleUrls: ['./report-general-cdms.component.scss'],
    standalone: false
})
export class ReportGeneralCDMSComponent {

}
